import {
  Button,
  Col,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Row,
} from "reactstrap";
import { FilterCard } from "./FilterCard";
import { getLanguageLabel } from "../../common/helpers/languageHelpers";
import { CyFilterCard } from "./CyFilterCard";
import { useTranslation } from "react-i18next";

interface Props {
  allTonalities: string[];
  selectedTonalities: string[];
  setSelectedTonalities: (
    value: ((prevState: string[]) => string[]) | string[],
  ) => void;
  allLanguages: string[];
  selectedLanguages: string[];
  setSelectedLanguages: (
    value: ((prevState: string[]) => string[]) | string[],
  ) => void;
  allTags: string[];
  selectedTags: string[];
  setSelectedTags: (
    value: ((prevState: string[]) => string[]) | string[],
  ) => void;
  isModalOpen: boolean;
  setIsModalOpen: (value: ((prevState: boolean) => boolean) | boolean) => void;
}

export function ItemsFilterModal({
  allTonalities,
  selectedTonalities,
  setSelectedTonalities,
  allLanguages,
  selectedLanguages,
  setSelectedLanguages,
  allTags,
  selectedTags,
  setSelectedTags,
  isModalOpen,
  setIsModalOpen,
}: Props) {
  const { t } = useTranslation();

  const toggle = () => setIsModalOpen((v) => !v);

  const handleSetSelectedTonalities = (
    value: ((prevState: string[]) => string[]) | string[],
  ) => {
    setSelectedTonalities(value);
    setIsModalOpen(false);
  };

  const handleSetSelectedLanguages = (
    value: ((prevState: string[]) => string[]) | string[],
  ) => {
    setSelectedLanguages(value);
    setIsModalOpen(false);
  };

  const handleSetSelectedTags = (
    value: ((prevState: string[]) => string[]) | string[],
  ) => {
    setSelectedTags(value);
    setIsModalOpen(false);
  };

  return (
    <Modal size="xl" isOpen={isModalOpen} fullscreen="md" toggle={toggle}>
      <ModalHeader toggle={toggle}>{t("common.filter")}</ModalHeader>
      <ModalBody>
        <Row className="align-items-stretch g-2">
          <Col md={12} lg={4}>
            <FilterCard
              title={t("items.filter.tonality")}
              all={allTonalities}
              selected={selectedTonalities}
              setSelected={handleSetSelectedTonalities}
              dataCy={CyFilterCard.TonalityFilter}
            />
          </Col>
          <Col md={12} lg={4}>
            <FilterCard
              title={t("items.filter.language")}
              all={allLanguages}
              selected={selectedLanguages}
              setSelected={handleSetSelectedLanguages}
              valueToLabelMapper={getLanguageLabel}
              dataCy={CyFilterCard.LanguageFilter}
            />
          </Col>
          <Col md={12} lg={4}>
            <FilterCard
              title={t("items.filter.tags")}
              all={allTags}
              selected={selectedTags}
              setSelected={handleSetSelectedTags}
              dataCy={CyFilterCard.TagsFilter}
            />
          </Col>
        </Row>
      </ModalBody>
      <ModalFooter>
        <Button color="primary" onClick={toggle}>
          {t("common.buttons.close")}
        </Button>
      </ModalFooter>
    </Modal>
  );
}
